// Anfragen an den Sitzungsserver. Jede Funktion liefert { daten } oder { status },
// damit die Ansicht selbst entscheidet, was ein Fehler bedeutet.

async function anfrage(methode, pfad, { koerper, schluessel } = {}) {
    const kopf = {}
    if (koerper !== undefined) kopf['Content-Type'] = 'application/json'
    if (schluessel) kopf['Authorization'] = `Bearer ${schluessel}`
    try {
        const antwort = await fetch(`/api${pfad}`, {
            method: methode,
            headers: kopf,
            body: koerper === undefined ? undefined : JSON.stringify(koerper)
        })
        if (!antwort.ok) return { status: antwort.status }
        if (antwort.status === 204) return { daten: null }
        return { daten: await antwort.json() }
    } catch {
        // Kein Netz oder Server weg.
        return { status: 0 }
    }
}

export function sitzungEroeffnen(passwort, konfiguration) {
    return anfrage('POST', '/sitzung', { koerper: { passwort, konfiguration } })
}

export function uebersichtLaden(code, lehrerSchluessel) {
    return anfrage('GET', `/sitzung/${code}/uebersicht`, { schluessel: lehrerSchluessel })
}

export function beitreten(code) {
    return anfrage('POST', `/sitzung/${code}/beitreten`)
}

export function standSenden(code, token, stand) {
    return anfrage('PUT', `/sitzung/${code}/stand`, { koerper: { stand }, schluessel: token })
}

export function ichPruefen(code, token) {
    return anfrage('GET', `/sitzung/${code}/ich`, { schluessel: token })
}

export function beitrittSetzen(code, lehrerSchluessel, offen) {
    return anfrage('PUT', `/sitzung/${code}/beitritt`, { koerper: { offen }, schluessel: lehrerSchluessel })
}

export function sitzungBeenden(code, lehrerSchluessel) {
    return anfrage('DELETE', `/sitzung/${code}`, { schluessel: lehrerSchluessel })
}
